// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tree[data-v-5614d8c9]{padding:24px 0 24px 24px;width:100%;height:100%;font-size:12px;color:#595959}", ""]);
// Exports
module.exports = exports;
